import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { Amplify } from 'aws-amplify';
import { environment } from '../environment/environment';

import { SignupComponent } from './auth/signup/signup.component';
import { HomeComponent } from './home/home.component';
import { SidebarComponent } from './user/sidebar/sidebar.component';
import { BannerComponent } from './user/banner/banner.component';
import { HeaderComponent } from './user/header/header.component';
import { CategoryComponent } from './user/category/category.component';
import { CategoryBrowserComponent } from './user/category-browser/category-browser.component';
import { MyFavoritesComponent } from './user/my-favorites/my-favorites.component';
import { CashbackComponent } from './user/cashback/cashback.component';
import { CategoryDetailComponent } from './user/category-detail/category-detail.component';
import { SelectFavoriteAppComponent } from './user/select-favorite-app/select-favorite-app.component';
import { CashbackRequestComponent } from './user/cashback-request/cashback-request.component';

import { AuthGuard } from './services/guards/auth.guard';
import { AuthService } from './services/auth.service';
import { TokenInterceptor } from './services/token.interceptor';
import { BannerService } from './osm-services/banner.service';
import { ConfigFactoryProvider, ConfigService } from './services/app.config.service';
import { RuntimeConfigService, RuntimeConfigFactory } from './services/runtime-config.service';

import { SubCategoryComponent } from './user/sub-category/sub-category.component';
import { AlertComponent } from './common/alert/alert.component';
import { AlertService } from './common/alert/alert.service';
import { AdminAppliListComponent } from './admin/appli/appli-list/appli-list.component';
import { AdminAppliDetailComponent } from './admin/appli/appli-detail/appli-detail.component';
import { AdminCategoryListComponent } from './admin/catetory/category-list/category-list.component';
import { AdminSubCategoryListComponent } from './admin/sub-category/sub-category-list/sub-category-list.component';
import { AgGridModule } from 'ag-grid-angular';
import { LoginComponent } from './auth/login/login.component';
import { AppManagerComponent } from './components/app-manager/app-manager.component';


Amplify.configure({
	Auth: environment.cognitoConfig
});

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SignupComponent,
    HomeComponent,
    BannerComponent,
    SidebarComponent,
    HeaderComponent,
    CategoryComponent,
    CategoryBrowserComponent,
    MyFavoritesComponent,
    CashbackComponent,
    CategoryDetailComponent,
    SelectFavoriteAppComponent,
    CashbackRequestComponent,
    SubCategoryComponent,
    AlertComponent,
    AdminAppliListComponent,
    AdminAppliDetailComponent,
    AdminCategoryListComponent,
    AdminSubCategoryListComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    AgGridModule,
    AppManagerComponent, // Standalone component
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: ConfigFactoryProvider,
      deps: [ConfigService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: RuntimeConfigFactory,
      deps: [RuntimeConfigService],
      multi: true,
    },
    RuntimeConfigService,
    // WindowReferenceService,
    // GtmDataLayerService,
    // TawkService,
    AlertService
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
